const seoListingOptimization = ({ language, isSavedUser }) => {
  return {
    title: "SEO Listing Optimization",
    subtitle:
      "Get winning and ready-to-use product listings with relevant keywords that help ensure that your product stands out among search results",
    href: "https://listing.sellerhook.com/?utm_source=site&utm_medium=amzscout&utm_campaign=menu",
    isBlank: true,
  };
};

export default seoListingOptimization;
